<template>
	<div>
		<NavBar :admin="true" :items="items" />
		<v-main>
			<v-container>
				<p class="text-h5 mt-2" v-translate>Alerts</p>
				<v-btn small fab class="mb-3" color="primary" @click="showNewAlertForm = !showNewAlertForm">
					<v-icon>mdi-plus</v-icon>
				</v-btn>
				<template v-if="showNewAlertForm">
					<v-form ref="newAlertForm" v-model="validForm">
						<v-row no-gutters>
              <v-col cols="12">
								Título PT
								<RichTextEditor key="pt-title" ref="titlePT" :text="newAlert.title_pt" />
							</v-col>
              <v-col cols="12">
								Título EN
								<RichTextEditor key="en-title" ref="titleEN" :text="newAlert.title_en" />
							</v-col>
              <v-col cols="12">
								Título ES
								<RichTextEditor key="es-title" ref="titleES" :text="newAlert.title_es" />
							</v-col>
							<v-col cols="12">
								PT
								<RichTextEditor key="pt-text" ref="textPT" :text="newAlert.text_pt" />
							</v-col>
							<v-col cols="12">
								EN
								<RichTextEditor key="en-text" ref="textEN" :text="newAlert.text_en" />
							</v-col>
							<v-col cols="12">
								ES
								<RichTextEditor key="es-text" ref="textES" :text="newAlert.text_es" />
							</v-col>
							<v-col cols="6">
								<v-checkbox
									v-model="newAlert.active"
									class="mt-0 pt-0"
									color="primary"
									:label="$gettext('Active')"
									hide-details
								/>
							</v-col>
							<v-col cols="6">
								<v-file-input
									accept="image/png, image/jpeg, image/bmp"
									label="Imagem"
									v-model="imageUpload"
									outlined
									class="px-2"
									hide-details
								></v-file-input>
							</v-col>
						</v-row>
					</v-form>
					<v-row no-gutters class="mb-4">
						<v-spacer></v-spacer>
						<v-btn color="primary" class="mb-2" @click="addAlert">
							<translate>Add</translate>
						</v-btn>
					</v-row>
				</template>
				<v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
        <Alert v-else v-for="alert in alerts" :key="alert.id" :alert="alert" @delete-alert="deleteAlert" />
			</v-container>
		</v-main>
	</div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import Alert from "@/components/admin/Alert.vue";
import axios from "axios";
import RichTextEditor from "@/components/RichTextEditor.vue";

export default {
  name: "Alerts",
  components: {
    NavBar,
		Alert,
		RichTextEditor
	},
	data: () => ({
    alerts: [],
		showNewAlertForm: false,
		newAlert: {
      title_pt: "",
      title_en: "",
      title_es: "",
			text_pt: "",
			text_en: "",
			text_es: "",
			active: true
		},
		validForm: false,
		loading: true,
		imageUpload: null
	}),
	computed: {
		items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: this.$gettext("Alerts"),
					disabled: true,
					link: true
				}
			];
    },
    required() {
			return value => !!value || this.$gettext("Required.");
		}
  },
  methods: {
    addAlert() {
      if (this.$refs.newAlertForm.validate()) {
				const form = new FormData();
        form.append("title_pt", this.$refs.titlePT.getHTML());
        form.append("title_en", this.$refs.titleEN.getHTML());
        form.append("title_es", this.$refs.titleES.getHTML());
				form.append("text_pt", this.$refs.textPT.getHTML());
				form.append("text_en", this.$refs.textEN.getHTML());
				form.append("text_es", this.$refs.textES.getHTML());
				form.append("active", this.newAlert.active);
				form.append("image_upload", this.imageUpload);
				axios
					.post("/admin/alerts/new", form)
					.then(response => {
						console.log(response.data);
						if (response.data.result == "ok") {
              this.alerts.unshift(response.data.alert);
              this.newAlert.title_pt = "";
              this.newAlert.title_en = "";
              this.newAlert.title_es = "";
							this.newAlert.text_pt = "";
							this.newAlert.text_en = "";
							this.newAlert.text_es = "";
							this.newAlert.active = true;
							this.showNewAlertForm = false;
							this.imageUpload = null;
						}
					})
					.catch(error => console.log(error));
      }
    },
    deleteAlert(alert) {
      this.alerts.splice(this.alerts.indexOf(alert), 1);
    }
  },
  created() {
		axios
			.get("/admin/alerts")
			.then(response => {
        console.log(response.data);
				if (response.status === 200) {
					this.alerts = response.data.alerts;
					this.loading = false;
				}
			})
			.catch(error => console.log(error));
  }
};
</script>